
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/kolledzh/[id]",
      function () {
        return require("private-next-pages/programs/kolledzh/[id]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/kolledzh/[id]"])
      });
    }
  